/**
 * firebase/auth wrapper
 * Thin abstraction around Firebase Auth SDK calls used by AuthContext.
 *
 * Intent:
 * - keep SDK imports isolated
 * - centralize config assertion before auth actions
 */
import {
  GoogleAuthProvider,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
} from 'firebase/auth';
import { assertFirebaseConfigured, auth } from './config';

const provider = new GoogleAuthProvider();

export async function signInWithGooglePopup() {
  assertFirebaseConfigured();
  return signInWithPopup(auth, provider);
}

export async function signInWithEmail(email, password) {
  assertFirebaseConfigured();
  return signInWithEmailAndPassword(auth, email, password);
}

export async function registerWithEmail(email, password) {
  assertFirebaseConfigured();
  return createUserWithEmailAndPassword(auth, email, password);
}

export async function signOutCurrentUser() {
  assertFirebaseConfigured();
  return signOut(auth);
}
